import { User } from '@mi-front/core';
import { Box, Typography } from '@mui/material';
import { getAppUserDisplayName } from '../../../helpers/user';

export function QuickUserInfo(p: { user: User; size?: 'sm'; className?: string }) {
  return (
    <Box className={p.className}>
      <Box>{getAppUserDisplayName(p.user)}</Box>
      <Typography
        component="span"
        className="text-muted"
        sx={{
          fontSize: p.size === 'sm' ? '0.75rem' : '0.875rem',
        }}
      >
        {p.user.email}
      </Typography>
    </Box>
  );
}
